import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { debounceTime, filter, Observable, Subscription } from 'rxjs';
import { Site } from 'src/app/model/site';
import { AppState } from 'src/app/store/app.reducer';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { StandardDesignParameters, StandardMtmaLayout, StandardPageLayout, StandardTruncateString } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { convertDbStandartIcon, convertOldIcon, DeviceIcon } from 'src/app/conf/device-icons';
import { DevicesTree } from 'src/app/model/device-tree';
import { EDeviceModel } from 'src/app/conf/device-models';
// import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { User } from 'src/app/model/user';
import { Lang } from 'src/app/model/lang';
import { DEFAULT_LANG } from 'src/app/conf/languages';
import { TranslateService } from '@ngx-translate/core';
import { AppComponent } from 'src/app/app.component';
import { selectCurrentSite, selectSites } from 'src/app/store/site/site.selector';
import { selectCurrentLang, selectIsDraftMode, selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { selectDeviceVctAuxEdited, selectDeviceVctDeleted, selectDeviceVctFeatureEdited, selectDeviceVctInvitationAppReseted, selectDeviceVctModuleEdited, selectDeviceVctShared, selectVctInvitationsList, selectVctLoadingInvitations, selectLoadingDevicesVctList, selectVctPlantsList, selectVctSitesList } from 'src/app/store/device-vct/device-vct.selector';
import { FeatureVct, ModuleVct, Plant, SettingVct, SipAccountVct } from 'src/app/model/device-vct/device-vct-implant';
import { DevicesVctFeatures, DevicesVctModules, DevicesVctSettings } from 'src/app/conf/devices-vct';
import { InvitationVct } from 'src/app/model/device-vct/device-vct-invitations';
import { FormControl, FormGroup } from '@angular/forms';
import { ShareDeviceVctDialogComponent } from '../share-device-vct-dialog/share-device-vct.dialog.component';
import { AuxConfigDeviceVctDialogComponent } from '../aux-config-device-vct-dialog/aux-config-device-vct.dialog.component';
import { VctAbandonPlantDialogComponent } from '../../shared/components/vct-abandon-plant-dialog/vct-abandon-plant.dialog.component';
import { EditIntercommunicatingVctDialogComponent } from '../edit-intercommunicating-vct-dialog/edit-intercommunicating-vct.dialog.component';
import { EditUnitVctDialogComponent } from '../edit-unit-vct-dialog/edit-unit-vct.dialog.component';
import { EditOperatorsVctDialogComponent } from '../edit-operators-vct-dialog/edit-operators-vct.dialog.component';
import { EditDeviceVctDialogComponent } from '../edit-device-vct-dialog/edit-device-vct.dialog.component';
import { selectCurrentDeviceSuccess, selectDevicesStatus } from 'src/app/store/device/device.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { DeviceStatus } from 'src/app/model/device-status';

@Component({
	selector: 'app-devices-vct-list',
	templateUrl: './devices-vct-list.component.html',
	providers: [ConfirmationService, DialogService],
	styles: `
		:host ::ng-deep .p-treetable-tbody > tr {
			height: 70px; // height of table row -> use same value for [virtualScrollItemSize]
		}
	`
})

export class DevicesVctListComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	plantsList$: Observable<Plant[] | undefined>;
	plantsListSub: Subscription | undefined;
	invitationList$: Observable<InvitationVct[] | undefined>;
	invitationListSub: Subscription | undefined;
	deviceVctShared$: Observable<boolean | undefined>;
	deviceVctSharedSub: Subscription;
	deviceVctDeleted$: Observable<boolean | undefined>;
	deviceVctDeletedSub: Subscription;
	deviceVctModuleEdited$: Observable<boolean | undefined>;
	deviceVctModuleEditedSub: Subscription;
	deviceVctFeatureEdited$: Observable<boolean | undefined>;
	deviceVctFeatureEditedSub: Subscription;
	deviceVctAuxEdited$: Observable<boolean | undefined>;
	deviceVctAuxEditedSub: Subscription;
	deviceVctInvitationAppReseted$: Observable<boolean | undefined>;
	deviceVctInvitationAppResetedSub: Subscription;
	loadingList$: Observable<boolean | undefined>;
	loadingListSub: Subscription;
	loadingInvitations$: Observable<boolean | undefined>;
	loadingInvitationsSub: Subscription;
	vctSitesList$: Observable<Site[] | undefined>;
	vctSitesListSub: Subscription | undefined;
	sites$: Observable<Site[] | undefined>;
	sitesSub: Subscription | undefined;
	devicesStatus$: Observable<DeviceStatus[] | undefined>;
	devicesStatusSub: Subscription | undefined;

	devicesStatus: DeviceStatus[] = [];

	loadingInvitations = false;
	loadingList = false;

	vctSitesList: Site[];
	currentSite: Site;
	plantsList: Plant[];
	invitationList: InvitationVct[];
	sites: Site[];
	sharedSiteAutomationsThs: Site[];

	devicesTree: DevicesTree;
	devices: TreeNode[] = [];
	virtualEnableScroll = false;
	private readonly MIN_ITEMS_VIRTUAL_SCROLL = 13;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	isDraftMode: boolean;
	isDraftMode$: Observable<boolean | undefined>;
	isDraftModeSub: Subscription;

	currentDeviceSuccess: boolean;
	currentDeviceSuccess$: Observable<boolean | undefined>;
	currentDeviceSuccessSub: Subscription;

	ref: DynamicDialogRef | undefined;

	deviceFilters: FormGroup;
	filterSub: Subscription;

	// site: Site;
	acceptButtonStyle: string;
	rejectButtonStyle: string;

	screenWidth: number;
	MIN_WIDTH_COL6 = StandardDesignParameters.MIN_WIDTH_COL6;
	LG_WIDTH = StandardDesignParameters.LG_WIDTH;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
		private router: Router,
		private route: ActivatedRoute,
		public app: AppComponent
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.deviceFilters = new FormGroup({
			'searchFilter': new FormControl(''),
			'assignFilter': new FormControl(true),
			'pendingFilter': new FormControl(true),
			'notAssignFilter': new FormControl(true),
			'onlyUnit': new FormControl(false),
			// 'type': new FormControl(this.siteType[0].value),
		});
		this.onCurrentSiteChange();
		this.subscribeAll();
		this.onTreeDevicesChange();
		this.onResize();
		// setTimeout(() => {
		// 	this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'List Device | VCT' } }));
		// }, 2000);
		this.filterSub = this.deviceFilters.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			this.generateTreeNode();
		});
	}

	initSelectors(): void {
		this.site$ = this.store.select(selectCurrentSite);
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.currentUser$ = this.store.select(selectUser);
		this.isDraftMode$ = this.store.select(selectIsDraftMode);
		this.plantsList$ = this.store.select(selectVctPlantsList);
		this.invitationList$ = this.store.select(selectVctInvitationsList);
		this.deviceVctDeleted$ = this.store.select(selectDeviceVctDeleted);
		this.deviceVctShared$ = this.store.select(selectDeviceVctShared);
		this.deviceVctModuleEdited$ = this.store.select(selectDeviceVctModuleEdited);
		this.deviceVctFeatureEdited$ = this.store.select(selectDeviceVctFeatureEdited);
		this.deviceVctAuxEdited$ = this.store.select(selectDeviceVctAuxEdited);
		this.deviceVctInvitationAppReseted$ = this.store.select(selectDeviceVctInvitationAppReseted);
		this.loadingList$ = this.store.select(selectLoadingDevicesVctList);
		this.loadingInvitations$ = this.store.select(selectVctLoadingInvitations);
		this.vctSitesList$ = this.store.select(selectVctSitesList);
		this.sites$ = this.store.select(selectSites);
		this.currentDeviceSuccess$ = this.store.select(selectCurrentDeviceSuccess);
		this.devicesStatus$ = this.store.select(selectDevicesStatus);
	}

	subscribeAll(): void {
		this.plantsListSub = this.plantsList$?.subscribe(plantsList => {
			this.plantsList = plantsList;
			this.generateTreeNode();
		});
		this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.currentUserSub = this.currentUser$?.subscribe(
			(currentUser) => {
				this.currentUser = currentUser;
			}
		);
		this.isDraftModeSub = this.isDraftMode$.subscribe(
			(isDraftMode) => {
				this.isDraftMode = isDraftMode;
			}
		);
		this.siteSub = this.site$?.pipe(filter(currentSite => !!currentSite)).subscribe(
			(currentSite) => {
				this.currentSite = currentSite;
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		);
		this.sitesSub = this.sites$?.pipe(
		).subscribe((sites) => {
			this.sites = sites;
		});
		this.vctSitesListSub = this.vctSitesList$.subscribe(
			(sites) => {
				this.vctSitesList = sites;
				// site shared automations and ths without vct plant are not in vctSitesList
				this.sharedSiteAutomationsThs = this.sites.filter(
					site => !this.vctSitesList.some(vct => vct.Id === site.Id)
				);
				if (this.vctSitesList.length > 0 && this.currentSite !== undefined && this.currentSite !== null) {
					if (!this.vctSitesList.some(vctSite => vctSite.Id === this.currentSite.Id) && 
						!this.sharedSiteAutomationsThs.some(site => site.Id === this.currentSite.Id)) {
						this.goToSitesVoiceMenu();
					}
				}
			}
		);
		this.invitationListSub = this.invitationList$.subscribe(
			(invitationList) => {
				this.invitationList = invitationList;
			}
		);
		this.deviceVctSharedSub = this.deviceVctShared$.subscribe((shared) => {
			if (shared) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.deviceVctDeletedSub = this.deviceVctDeleted$.subscribe((deleted) => {
			if (deleted) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.deviceVctModuleEditedSub = this.deviceVctModuleEdited$.subscribe((edited) => {
			if (edited) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.deviceVctFeatureEditedSub = this.deviceVctFeatureEdited$.subscribe((edited) => {
			if (edited) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					// this.refreshData();
				}
			}
		});
		this.deviceVctAuxEditedSub = this.deviceVctAuxEdited$.subscribe((edited) => {
			if (edited) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					// this.refreshData();
				}
			}
		});
		this.deviceVctInvitationAppResetedSub = this.deviceVctInvitationAppReseted$.subscribe((edited) => {
			if (edited) {
				if (this.currentSite !== undefined && this.currentSite.Id !== undefined) {
					this.refreshData();
				}
			}
		});
		this.loadingListSub = this.loadingList$.subscribe((loadingList) => {
			this.loadingList = loadingList;
		});
		this.loadingInvitationsSub = this.loadingInvitations$.subscribe((loadingInvitations) => {
			this.loadingInvitations = loadingInvitations;
		});
		this.currentDeviceSuccessSub = this.currentDeviceSuccess$.subscribe((currentDeviceSuccess) => {
			this.currentDeviceSuccess = currentDeviceSuccess;
		})
	}

	onCurrentSiteChange(): void {
		this.siteSub = this.site$?.pipe(filter(currentSite => !!currentSite))
			.subscribe(currentSite => {
				this.currentSite = currentSite;
				if (currentSite.Devices !== undefined && currentSite.Devices.length > 0) {
					const deviceIds: number[] = currentSite.Devices.map(d => d.Id);
					this.store.dispatch(DeviceActions.getDevicesStatus({ deviceIds }));
				} else {
					this.devicesStatus = [];
					this.devices = [];
				}
			}
		);
	}
	
	onTreeDevicesChange(): void {
		this.devicesStatusSub = this.devicesStatus$?.pipe(filter(ds => ds.length > 0))
			.subscribe(
				devicesStatus => {
					if (!this.currentSite) {
						return;
					}
					this.devicesStatus = devicesStatus;
				}
			);
	}

	ngOnDestroy(): void {
		this.store.dispatch(NotificationsActions.resetTopbarTitleId());
		this.siteSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isDraftModeSub?.unsubscribe();
		this.invitationListSub?.unsubscribe();
		this.deviceVctModuleEditedSub?.unsubscribe();
		this.deviceVctFeatureEditedSub?.unsubscribe();
		this.plantsListSub?.unsubscribe();
		this.deviceVctAuxEditedSub?.unsubscribe();
		this.deviceVctInvitationAppResetedSub?.unsubscribe();
		this.loadingListSub?.unsubscribe();
		this.loadingInvitationsSub?.unsubscribe();
		this.vctSitesListSub?.unsubscribe();
		this.currentDeviceSuccessSub?.unsubscribe();
		this.devicesStatusSub?.unsubscribe();
	}

	// trigger event from vct-list-filter
	onReloadButtonEvent(): void {
		this.refreshData();
	}

	goToSitesVoiceMenu() {
		// this.router.navigate(['../sites'], { relativeTo: this.route });
	}

	refreshData(): void {
		this.store.dispatch(DeviceVctActions.getDevicesVctList());
		this.store.dispatch(DeviceVctActions.getVctInvitations());
		this.updateScrollState();
	}

	generateIcon(device: DevicesTree): string {
		//TODO ICONE PRODOTTI
		let icon = '';
		if (device.ModelId !== EDeviceModel.MultiIO) {
			icon = 'cm-' + DeviceIcon[device.ModelId];
		} else {
			icon = 'cm-' + device.IconName.toLowerCase() || 'cm-' + DeviceIcon[device.ModelId] || 'cm-device-gateway';
		}
		switch (icon) {
			case 'cm-undefined': {
				return convertDbStandartIcon(device.IconName);
			}
			default: {
				return convertOldIcon(icon);
			}
		}
		return icon;
	}

	generateTreeNode(): void {
		this.devices = [];
		for (const dev of this.plantsList) {
			this.devices.push(this.createTreeNode(dev));
		}
		this.updateScrollState();
	}

	createTreeNode(device: Plant): TreeNode {
		const onlyUnit = this.f.onlyUnit.value;
		let tree = {};
		if (device !== undefined && device.Id) {
			const mainChild = [];
			const unitList = [];
			const targa = [];
			for (const module of device.Modules) {
				const appList = [];
				const moduleAccess = this.isAssignOwner(module);
				if (module.Features !== undefined && module.Features.length > 0 && this.isAccessFeatureModule(module) && !onlyUnit) {
					for (const feature of module.Features) {
						if (feature.FeatureId === DevicesVctFeatures.App && this.checkMailStatusApp(feature) &&
							(this.checkNameFilter(feature) || this.checkNameFilter(module) ||
								this.checkMailAssignApp(feature) || this.checkMailAssignUnit(module) ||
								this.checkMailPendingApp(feature) || this.checkMailPendingUnit(module))) {
							feature.ModuleAccess = moduleAccess;
							appList.push({ label: 'NO_DEVICES', data: feature, icon: "pi cm-devices", children: [], expanded: true });
						}
					}
				}
				if (module.ModuleId === DevicesVctModules.VideoUnit && (this.checkMailStatusUnit(module) &&
					(this.checkNameFilter(module) || this.checkMailAssignUnit(module) ||
						this.checkMailPendingUnit(module)) || appList.length > 0)) {
					unitList.push({ label: 'NO_DEVICES', data: module, icon: "pi cm-derivate", children: appList, expanded: true });
				}
				if (module.ModuleId === DevicesVctModules.Targa && this.checkNameFilter(module)) {
					targa.push({ label: 'NO_DEVICES', data: module, icon: "pi cm-plate", children: [], expanded: true });
				}
			}
			if (unitList.length > 0) {
				mainChild.push({ label: 'NO_DEVICES', data: { Name: this.translate.instant('LIST_UNIT') }, icon: "pi cm-derivate", children: unitList, expanded: true });
			}
			if (targa.length > 0) {
				mainChild.push({ label: 'NO_DEVICES', data: { Name: this.translate.instant('LIST_OPERATORS') }, icon: "pi cm-plate", children: targa, expanded: true });
			}
			tree = { label: 'NO_DEVICES', data: device, icon: "pi cm-folder-trunk", children: mainChild, expanded: true };
		}
		return tree;
	}

	getStyleGatewayPlantRow(rowNodeLevel: number): string {
		if (rowNodeLevel === 0) {
			let retStrStyle: string = 'surface-400 hover:bg-blue-200 border-top-1 border-bluegray-900';
			if (this.currentSite.CurrentlyOwned) {
				retStrStyle = retStrStyle + ' cursor-pointer';
			}
			return retStrStyle;
		} else {
			return '';
		}
	}

	selectDevice(deviceId: number, rowNodeLevel: number, data: any): void {
		this.store.dispatch(DeviceActions.passwordVerifySupportReset());
		if (rowNodeLevel === 0 && this.isPlant(data) && this.isOwner(data)) {
			this.store.dispatch(DeviceActions.getCurrentDevice({ deviceId: deviceId }));
			setTimeout(() => {
				if (this.currentDeviceSuccess) {
					const urlRoute = '../devices/' + deviceId;
					this.router.navigate([urlRoute], { relativeTo: this.route });
				}
			}, 300);
		}
	}

	getDeviceStatus(nodeId: number): DeviceStatus {
		let devSt = undefined;
		for (let i = 0; i < this.devicesStatus.length && devSt === undefined; i++) {
			const ds = this.devicesStatus[i];
			if (ds.Id === nodeId) {
				devSt = ds;
			}
		}
		return devSt;
	}

	getStatus(deviceId: number): string {
		if (this.devicesStatus.length > 0) {
			const device: DeviceStatus = this.getDeviceStatus(deviceId);
			if (device === undefined || !device.Online) {
				return this.translate.instant('OFFLINE');
			} else if (device.Errored) {
				return this.translate.instant('GENERIC_ERROR');
			} else {
				return this.translate.instant('ONLINE');
			}
		}
		return '';
	}

	getStatusColor(deviceId: number): string {
		if (this.devicesStatus.length > 0) {
			const device: DeviceStatus = this.getDeviceStatus(deviceId);

			if (device === undefined || !device.Online) {
				return 'danger';
			} else if (device.Errored) {
				return 'warning';
			} else {
				return 'success';
			}
		}
		return '';
	}

	//----------------FILTER--------------------------------
	checkNameFilter(elem: any): boolean {
		const nameFilter = this.f.searchFilter.value;
		if (nameFilter === undefined || nameFilter === '') {
			return true;
		}
		if (elem.AliasName !== undefined && elem.AliasName !== '' && elem.AliasName.toLowerCase().includes(nameFilter.toLowerCase())) {
			return true;
		}
		if ((elem.AliasName === undefined || elem.AliasName === '') && elem.Name !== undefined && elem.Name !== '' && elem.Name.toLowerCase().includes(nameFilter.toLowerCase())) {
			return true;
		}
		return false;
	}

	checkMailAssignApp(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}
		if (elem.SipAccount !== undefined && elem.SipAccount.UserEmail !== undefined &&
			elem.SipAccount.UserEmail !== '' && elem.SipAccount.UserEmail.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}

	checkMailAssignUnit(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}
		if (elem.OwnerEmail !== undefined && elem.OwnerEmail !== '' && elem.OwnerEmail.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}

	checkMailPendingApp(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}
		const invitationPending = this.getInvitationPendingFeature(elem.Id);
		if (invitationPending !== undefined && invitationPending.Email !== undefined && invitationPending.Email !== '' &&
			invitationPending.Email.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}
	checkMailPendingUnit(elem: any): boolean {
		const mailFilter = this.f.searchFilter.value;
		if (mailFilter === undefined || mailFilter === '') {
			return true;
		}

		const invitationPending = this.getInvitationPendingModule(elem.Id);
		if (invitationPending !== undefined && invitationPending.Email !== undefined && invitationPending.Email !== '' &&
			invitationPending.Email.toLowerCase().includes(mailFilter.toLowerCase())) {
			return true;
		}
		return false;
	}
	checkMailStatusUnit(elem: any): boolean {
		const assignFilter = this.f.assignFilter.value;
		const pendingFilter = this.f.pendingFilter.value;
		const notAssignFilter = this.f.notAssignFilter.value;
		if (assignFilter && pendingFilter && notAssignFilter) {
			return true;
		}
		if (assignFilter && this.isAssignModulePlant(elem)) {
			return true;
		}
		if (pendingFilter && this.isModuleAssignPending(elem)) {
			return true;
		}
		if (notAssignFilter && this.isNotAssign(elem) && !this.isModuleAssignPending(elem)) {
			return true;
		}
		return false;
	}
	checkMailStatusApp(elem: any): boolean {
		const assignFilter = this.f.assignFilter.value;
		const pendingFilter = this.f.pendingFilter.value;
		const notAssignFilter = this.f.notAssignFilter.value;
		if (assignFilter && pendingFilter && notAssignFilter) {
			return true;
		}
		if (assignFilter && this.isAssignApp(elem)) {
			return true;
		}
		if (pendingFilter && this.isAssignAppPending(elem)) {
			return true;
		}
		if (notAssignFilter && this.isNotAssignApp(elem) && !this.isAssignAppPending(elem)) {
			return true;
		}
		return false;
	}
	//----------------FILTER--------------------------------

	onDeviceExpand(event: any) {
		if (event !== undefined && event.node !== undefined && event.node.data !== undefined && event.node.data.Expand !== undefined) {
			event.node.data.Expand = true;
		}
		this.updateScrollState();
	}

	onDeviceCollapse(event: any) {
		if (event !== undefined && event.node !== undefined && event.node.data !== undefined && event.node.data.Expand !== undefined) {
			event.node.data.Expand = false;
		}
		this.updateScrollState();
	}
	
	updateScrollState(): void {
		this.virtualEnableScroll = this.treeTableVirtualScrollEnabled();
	}

	// count how many visibile row node we have on treeTable
	treeTableVirtualScrollEnabled(): boolean {
		let countCurrentViewNodes = 0;

		const visit = (nodes: any[]): boolean => {
			for (const node of nodes) {
				// ogni nodo visitato è una riga visibile
				countCurrentViewNodes++;
				if (countCurrentViewNodes >= this.MIN_ITEMS_VIRTUAL_SCROLL) {
					return true; // break and return
				}

				// visit node if is expanded true and has childrens
				if (node.expanded && node.children?.length) {
					if (visit(node.children)) {
						return true;
					}
				}
			}
			return false;
		};

		visit(this.devices);
		return countCurrentViewNodes >= this.MIN_ITEMS_VIRTUAL_SCROLL;
	}

	getRowInfo(data: any): string {
		if (data !== undefined && data.ProductId !== undefined) {
			return this.currentSite.CurrentlyOwned ?  this.translate.instant('KEYCODE') + ': ' + data.Keycode : '';
		} else if (data !== undefined && data.FeatureId !== undefined &&
			data.FeatureId === DevicesVctFeatures.App && this.getSipAccountAppSettings(data) !== undefined) {
			return this.translate.instant('SIP_ACCOUNT') + ': ' + this.getSipAccountAppSettings(data).Value;
		}
		return '';
	}

	//----------------TAG SHARE--------------------------------
	showTagShare(data: any): boolean {
		if (data !== undefined && data.ModuleId === undefined && data.FeatureId === undefined && data.ProductId === undefined) {
			return false;
		}
		if (this.isPlant(data) && this.isPlantAssignPending(data)) {
			return false;
		}
		if (this.isModuleTarga(data)) {
			return false;
		}
		if (this.isModuleAssignPending(data)) {
			return false;
		}
		if (this.isFeatureApp(data) && this.isAssignAppPending(data)) {
			return false;
		}
		if (data !== undefined && (this.isOwnerById(data.OwnerId) || this.isAssignAppOwner(data))) {
			return true;
		}
		if (this.isAssignClient(data)) {
			return true;
		}
		if (this.isFeatureApp(data) && this.isAssignApp(data)) {
			return true;
		}
		return true;
	}

	getIconTagShare(data: any): string {
		if (this.isPlantAssignPending(data) || this.isModuleAssignPending(data) || this.isAssignAppPending(data)) {
			return 'pi cm-mail';
		}
		else if (data !== undefined && (this.isOwnerById(data.OwnerId) || this.isAssignAppOwner(data))) {
			return 'pi cm-user';
		}
		else if (this.isAssignClient(data)) {
			return 'pi cm-user';
		}
		/*else if (this.isFeatureApp(data) && this.isAssignAppPending(data)) {
			return this.translate.instant('INVITED_PENDING') + ': ' + (this.getInvitationPendingFeature(data.Id) ? this.getInvitationPendingFeature(data.Id).Email : '');
		} */
		else if (this.isFeatureApp(data) && this.isAssignApp(data)) {
			return 'pi cm-user';
		}
		return 'pi cm-cancel'; // not assigned and default
	}

	getTextTagShare(data: any): string {
		if (data !== undefined && (this.isOwnerById(data.OwnerId) || this.isAssignAppOwner(data))) {
			return this.translate.instant('OWNER');
		}
		/*else if (this.isModuleAssignPending(data)) {
			return this.translate.instant('INVITED_PENDING') + ': ' + (this.getInvitationPendingModule(data.Id) ? this.getInvitationPendingModule(data.Id).Email : '');
		} */
		else if (this.isAssignClient(data)) {
			return data.OwnerEmail;
		}
		/*else if (this.isFeatureApp(data) && this.isAssignAppPending(data)) {
			return this.translate.instant('INVITED_PENDING') + ': ' + (this.getInvitationPendingFeature(data.Id) ? this.getInvitationPendingFeature(data.Id).Email : '');
		} */
		else if (this.isFeatureApp(data) && this.isAssignApp(data)) {
			return data.SipAccount.UserEmail;
		}
		return this.translate.instant('NOT_ASSIGNED');
	}

	getSeverityTagShare(data: any): string {
		if (data !== undefined && (this.isOwnerById(data.OwnerId) || this.isAssignAppOwner(data))) {
			return 'info';
		}
		/*else if (this.isModuleAssignPending(data)) {
			return 'warning';
		} */
		else if (this.isAssignClient(data)) {
			return 'success';
		} else if (!this.isFeatureApp(data) && this.isNotAssign(data)) {
			return 'danger';
		}
		/*else if (this.isFeatureApp(data) && this.isAssignAppPending(data)) {
			return 'warning';
		} */
		else if (this.isFeatureApp(data) && this.isAssignApp(data)) {
			return 'success';
		}
		return 'danger';
	}

	//---------------- AUX FUNCTS TAG INVITATION (Pending) --------------------------------
	getInvitationPendingProduct(productId: number): InvitationVct {
		if (productId !== undefined && this.invitationList !== undefined && this.invitationList.length > 0) {
			return this.invitationList.find(inv => inv.SiteproductId !== undefined && inv.SiteproductId === productId &&
				inv.Rejected === null && inv.Accepted === null);
		}
		return undefined;
	}
	getInvitationPendingModule(moduleId: number): InvitationVct {
		if (moduleId !== undefined && this.invitationList !== undefined && this.invitationList.length > 0) {
			return this.invitationList.find(inv => inv.SitemoduleId !== undefined && inv.SitemoduleId === moduleId &&
				inv.Rejected === null && inv.Accepted === null);
		}
		return undefined;
	}
	getInvitationPendingFeature(featureId: number): InvitationVct {
		if (featureId !== undefined && this.invitationList !== undefined && this.invitationList.length > 0) {
			return this.invitationList.find(inv => inv.SitefeatureId !== undefined && inv.SitefeatureId === featureId &&
				inv.Rejected === null && inv.Accepted === null);
		}
		return undefined;
	}

	//---------------- TAG INVITATION (Pending) --------------------------------
	showTagShareInvitation(data: any): boolean {
		if (data !== undefined && data.ModuleId === undefined && data.FeatureId === undefined && data.ProductId === undefined) {
			return false;
		}
		if (this.isPlant(data) && this.isOwner(data) && this.isPlantAssignPending(data)) {
			return true;
		}
		if (this.isModuleTarga(data)) {
			return false;
		}
		if (this.isModuleAssignPending(data) || this.isAssignAppPending(data)) {
			return true;
		}
		return false;
	}

	getTextTagShareInvitation(data: any): string {
		if (this.isPlantAssignPending(data)) {
			return this.translate.instant('INVITED_PENDING') + ': ' + (this.getInvitationPendingProduct(data.Id) ? this.getInvitationPendingProduct(data.Id).Email : '');
		} else if (this.isModuleAssignPending(data)) {
			return this.translate.instant('INVITED_PENDING') + ': ' + (this.getInvitationPendingModule(data.Id) ? this.getInvitationPendingModule(data.Id).Email : '');
		} else if (this.isFeatureApp(data) && this.isAssignAppPending(data)) {
			return this.translate.instant('INVITED_PENDING') + ': ' + (this.getInvitationPendingFeature(data.Id) ? this.getInvitationPendingFeature(data.Id).Email : '');
		}
		return '';
	}

	getSeverityTagShareInvitation(data: any): string {
		if (this.isPlantAssignPending(data)) {
			return 'warning';
		} else if (this.isModuleAssignPending(data)) {
			return 'warning';
		} else if (this.isFeatureApp(data) && this.isAssignAppPending(data)) {
			return 'warning';
		}
		return '';
	}

	//----------------------DIALOG ACTION-----------------------------
	resetLicenceApp(data: any): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('RESET_LICENSE_APP'),
			message: this.translate.instant('RESET_LICENSE_APP_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceVctActions.resetVctInvitationApp({ featureId: data.Id }));
			},
			reject: () => {
			}
		});
	}

	abandonDevicePlants(device: Plant) { // Impianto
		this.ref = this.dialogService.open(VctAbandonPlantDialogComponent, {
			header: this.translate.instant('ABANDON_DEVICE_PLANTS'),
			contentStyle: { overflow: 'auto' },
			data: {
				device: device
			}
		});
	}

	abandonDeviceModule(device: Plant) { // Unità
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('ABANDON_DEVICE_UNIT'),
			message: this.translate.instant('ABANDON_DEVICE_UNIT_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceVctActions.abandonVctModule({ moduleId: device.Id, abandon: true }));
			},
			reject: () => {
			}
		});
	}

	abandonDeviceFeature(device: Plant) { // App
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('ABANDON_DEVICE_APP'),
			message: this.translate.instant('ABANDON_DEVICE_APP_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceVctActions.abandonVctFeature({ featureId: device.Id, abandon: true }));
			},
			reject: () => {
			}
		});
	}
	revokeAccessDeviceModule(device: Plant) {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('REVOKE_ACCESS_DEVICE_UNIT'),
			message: this.translate.instant('REVOKE_ACCESS_DEVICE_UNIT_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceVctActions.abandonVctModule({ moduleId: device.Id, abandon: false }));
			},
			reject: () => {
			}
		});
	}
	revokeAccessDeviceFeature(device: Plant) {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('REVOKE_ACCESS_DEVICE_APP'),
			message: this.translate.instant('REVOKE_ACCESS_DEVICE_APP_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceVctActions.abandonVctFeature({ featureId: device.Id, abandon: false }));
			},
			reject: () => {
			}
		});
	}
	revokeInvitation(invitation: InvitationVct) {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('REVOKE_INVITATION'),
			message: this.translate.instant('REVOKE_INVITATION_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceVctActions.removeVctInvitations({ invitationId: invitation.Token }));
			},
			reject: () => {
			}
		});
	}
	editPlant(device: Plant): void {
		if (device !== undefined && device.Id) {
			for (const module of device.Modules) {
				if (module.ModuleId === DevicesVctModules.Building) {
					this.editIntercommunicationgName(module);
					break;
				}
			}
		}
	}
	// Contacts intercomunication
	editIntercommunicationgName(module: ModuleVct): void {
		this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
		this.ref = this.dialogService.open(EditIntercommunicatingVctDialogComponent, {
			header: this.translate.instant('EDIT') + ' ' + this.translate.instant('INTERCOM_CONTACT').toLowerCase(),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module,
			},
		});
	}
	// Unit
	editModuleUnitName(module: ModuleVct): void {
		this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
		this.ref = this.dialogService.open(EditUnitVctDialogComponent, {
			header: this.translate.instant('EDIT_MODULE_UNIT'),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module,
			},
		});
	}
	// Varchi
	editModuleOperatorsName(module: ModuleVct): void {
		this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
		this.ref = this.dialogService.open(EditOperatorsVctDialogComponent, {
			header: this.translate.instant('EDIT') + ' ' + this.translate.instant('VCT_OPENS').toLowerCase(),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				module: module,
			},
		});

		// subscribe for dialog closed
		this.ref.onClose.subscribe((somethingIsSaved) => {
			// if click on 'x' dialog, somethingIsSaved is false so no refresh
			if (somethingIsSaved) {
				this.refreshData();
			}
		});
	}
	// Feature -> App Mobile
	editFeatureName(featureId: number, name: string): void {
		this.store.dispatch(DeviceVctActions.editVctFeatureNameReset());
		this.ref = this.dialogService.open(EditDeviceVctDialogComponent, {
			header: this.translate.instant('EDIT') + ' ' + this.translate.instant('APP_LICENSE').toLowerCase(),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				featureId: featureId,
				name: name
			},
		});
	}
	//----------------------DIALOG ACTION-----------------------------


	getSipAccountAppSettings(feature: FeatureVct): SettingVct {
		if (feature !== undefined && feature.FeatureId === DevicesVctFeatures.App && feature.Settings !== undefined && feature.Settings.length > 0) {
			for (const setting of feature.Settings) {
				if (setting.SettingId === DevicesVctSettings.SipAccount1) {
					return setting;
				}
			}
		}
		return undefined;
	}
	getAssignSipAccountApp(feature: FeatureVct): SipAccountVct {
		if (feature !== undefined && feature.FeatureId === DevicesVctFeatures.App && feature.Settings !== undefined && feature.Settings.length > 0) {
			for (const setting of feature.Settings) {
				if (setting.SettingId === DevicesVctSettings.SipAccount1) {
					const sipAccount = this.getSipAccount(setting.Value);
					if (sipAccount !== undefined && sipAccount !== null && sipAccount.UserEmail !== undefined && sipAccount.UserEmail !== '') {
						return sipAccount;
					}
				}
			}
		}
		return undefined;
	}
	getSipAccount(sipUser: string): SipAccountVct {
		for (const device of this.plantsList) {
			if (device !== undefined && device.Id) {
				for (const module of device.Modules) {
					if (module.SipAccounts !== undefined && module.SipAccounts.length > 0) {
						for (const feature of module.SipAccounts) {
							if (feature.SipUsername === sipUser) {
								return feature;
							}
						}
					}
				}
			}
		}
		return undefined;
	}

	get f(): any {
		return this.deviceFilters.controls;
	}

	//--------------------CHECK CONTROL------------------------------------------------
	isPlant(plant: Plant): boolean {
		if (plant !== undefined && plant.ProductId !== undefined) {
			return true;
		}
		return false;
	}
	isModuleUnit(module: ModuleVct): boolean {
		if (module !== undefined && module.ModuleId !== undefined && module.ModuleId === DevicesVctModules.VideoUnit) {
			return true;
		}
		return false;
	}

	// just childs under 'Lista varchi', plant, units and mobile aren't Targa
	isModuleTarga(module: ModuleVct): boolean {
		if (module !== undefined && module.ModuleId !== undefined && module.ModuleId === DevicesVctModules.Targa) {
			return true;
		}
		return false;
	}
	isNotAssign(plant: any): boolean {
		if (plant !== undefined && (plant.OwnerEmail === undefined || plant.OwnerId === null)) {
			return true;
		}
		return false;
	}
	isAssignModulePlant(plant: any): boolean {
		if (plant !== undefined && plant.OwnerId !== undefined && plant.OwnerId !== null) {
			return true;
		}
		return false;
	}
	isAssignOwner(data: any): boolean {
		if (data !== undefined && data.OwnerEmail !== undefined && data.OwnerEmail === this.currentUser?.Email) {
			return true;
		}
		return false;
	}
	isAssignClient(plant: any): boolean {
		if (plant !== undefined && plant.OwnerEmail !== undefined && plant.OwnerEmail !== '' && !this.isOwner(plant)) {
			return true;
		}
		return false;
	}
	isPlantAssignPending(plant: Plant): boolean {
		if (plant !== undefined && plant.OwnerId !== undefined && this.getInvitationPendingProduct(plant.Id) !== undefined) {
			return true;
		}
		return false;
	}
	isModuleAssignPending(module: ModuleVct): boolean {
		if (module !== undefined && module.ModuleId !== undefined && this.getInvitationPendingModule(module.Id) !== undefined) {
			return true;
		}
		return false;
	}
	isModuleAssignPendingClient(module: ModuleVct): boolean {
		if (module !== undefined && module.ModuleId !== undefined &&
			this.getInvitationPendingModule(module.Id) !== undefined && this.currentUser !== undefined && this.currentUser.Email !== undefined &&
			this.getInvitationPendingModule(module.Id).Email !== this.currentUser.Email) {
			return true;
		}
		return false;
	}
	isFeatureApp(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined && feature.FeatureId === DevicesVctFeatures.App) {
			return true;
		}
		return false;
	}
	isAssignAppPending(feature: FeatureVct): boolean {
		if (this.isFeatureApp(feature) && this.getInvitationPendingFeature(feature.Id)) {
			return true;
		}
		return false;
	}
	isAssignAppOwner(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined &&
			feature.FeatureId === DevicesVctFeatures.App &&
			this.currentUser !== undefined && this.currentUser.Email !== undefined && feature.SipAccount.UserEmail === this.currentUser.Email) {
			return true;
		}
		return false;
	}
	isAssignApp(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined && feature.FeatureId === DevicesVctFeatures.App &&
			feature.SipAccount.UserId !== undefined && feature.SipAccount.UserId !== null) {
			return true;
		}
		return false;
	}
	isNotAssignApp(feature: any): boolean {
		if (feature !== undefined && feature.FeatureId !== undefined && feature.FeatureId === DevicesVctFeatures.App && !this.isAssignApp(feature) && !this.isAssignAppPending(feature)) {
			return true;
		}
		return false;
	}
	isAccessFeatureModule(module: ModuleVct): boolean {
		if (this.isAssignOwner(module)) {
			return true;
		}
		if (this.isModuleAssignPendingClient(module)) {
			return false;
		}
		if (this.isModuleAssignPending(module)) {
			return true;
		}
		if (this.isNotAssign(module)) {
			return true;
		}
		return false;
	}
	isOwner(plant: Plant): boolean {
		if (plant !== undefined) {
			if (this.currentUser.Id === plant.OwnerId) {
				return true;
			}
		}
		return false;
	}
	isOwnerData(data: any): boolean {
		if (data === undefined || (data !== undefined && data.ModuleId === undefined && data.FeatureId === undefined && data.ProductId === undefined)) {
			return false;
		}
		if (data.OwnerId !== undefined && this.currentUser.Id === data.OwnerId) {
			return true;
		}
		if (this.isFeatureApp(data) && this.isAssignAppOwner(data)) {
			return true;
		}
		return false;
	}
	isOwnerById(id: number): boolean {
		if (id !== undefined) {
			if (this.currentUser.Id === id) {
				return true;
			}
		}
		return false;
	}
	isPresentIntercomunicationData(data: any): boolean {
		if (data === undefined || data.ProductId === undefined) {
			return false;
		}
		if (data.Modules !== undefined && data.Modules.length > 0 && data.Modules.find(mod => mod.ModuleId === DevicesVctModules.Building) !== undefined) {
			return true;
		}
		return false;
	}
	//--------------------CHECK CONTROL------------------------------------------------

	//-------------------VISIBLE BUTTON FUNCTION---------------------------------------
	shareVisible(data: any): boolean {
		if (data !== undefined && data.ModuleId === undefined && data.FeatureId === undefined && data.ProductId === undefined) {
			return false;
		}
		if (this.isPlant(data) && this.isAssignOwner(data)) {
			return true;
		}
		if (this.isModuleUnit(data) && !this.isModuleAssignPending(data) && !this.isAssignClient(data)) {
			return true;
		} else if (data !== undefined && this.isFeatureApp(data) && !this.isAssignAppPending(data) && !this.isAssignApp(data) && data.ModuleAccess) {
			return true;
		}
		return false;
	}

	editIntercomContactVisible(data: any): boolean {
		if (data === undefined || data.ProductId === undefined) {
			return false;
		}
		if (this.isPresentIntercomunicationData(data)) {
			return true;
		}
		return false;
	}

	editVisible(data: any): boolean {
		if (data !== undefined && data.ModuleId !== undefined && (this.isAssignOwner(data) || data.OwnerEmail === undefined)) { // UV
			return true;
		} else if (data !== undefined && data.FeatureId !== undefined && data.ModuleAccess) { // App Mobile
			return true;
		}
		return false;
	}

	abandonVisible(data: any): boolean {
		if (!this.isModuleTarga(data) && this.isOwnerData(data)) {
			return true;
		}
		return false;
	}

	resetLicenseVisible(data: any): boolean {
		return this.isFeatureApp(data) && this.isAssignApp(data);
	}

	revokeInvitationsVisible(data: any): boolean {
		return !this.isModuleTarga(data) && (this.isModuleAssignPending(data) || this.isAssignAppPending(data));
	}

	// !! NOTE: revokeAccess is not revokeInvitations
	// I can revokeAccess to UV if i'm admin plant
	// I can revokeAccess to App Mobile if i'm UV owner
	revokeAccessVisible(data: any): boolean {
		// plant couldn't be revoked, just abandoned
		// isAssignClient(data) true -> client (Unit) is assigned to someone
		// isAssignApp(data) true -> App is assigned to someone (not me owner)
		return (!this.isModuleTarga(data) && !this.isPlant(data) && (this.isAssignClient(data) || (this.isAssignApp(data) && !this.isAssignAppOwner(data))));
	}

	configAuxCommandsVisible(data: any): boolean {
		return this.isModuleTarga(data) && this.currentSite.CurrentlyOwned;
	}
	//-------------------VISIBLE BUTTON FUNCTION---------------------------------------
	//-------------------ASSIGN  BUTTON FUNCTION---------------------------------------

	shareDevice(data: any): void {
		if (data !== undefined && data.ProductId !== undefined) {
			this.shareDeviceProduct(data.Id);
		}
		if (data !== undefined && data.ModuleId !== undefined) {
			this.shareDeviceModule(data.Id);
		}
		if (data !== undefined && data.FeatureId !== undefined) {
			this.shareDeviceFeature(data.Id);
		}
	}

	// edit: plant, UV, App, operators
	editDeviceName(data: any): void {
		if (data !== undefined && data.ProductId !== undefined) {
			this.editPlant(data);
		}
		if (data !== undefined && data.ModuleId !== undefined && data.ModuleId !== DevicesVctModules.Targa) {
			this.editModuleUnitName(data);
		}
		if (data !== undefined && data.ModuleId !== undefined && data.ModuleId !== DevicesVctModules.VideoUnit) {
			this.editModuleOperatorsName(data);
		}
		if (data !== undefined && data.FeatureId !== undefined) {
			let name = data.Name;
			if (data.AliasName !== '') {
				name = data.AliasName;
			}
			this.editFeatureName(data.Id, name);
		}
		/*if (data !== undefined && data.FeatureId !== undefined) {
			let name = data.Name;
			if (data.AliasName !== '') {
				name = data.AliasName;
			}
			this.editFeatureName(data.Id, name);
		}*/
	}

	abandonDevice(data: any): void {
		if (data !== undefined && data.ProductId !== undefined) {
			this.abandonDevicePlants(data);
		}
		if (data !== undefined && data.ModuleId !== undefined) {
			this.abandonDeviceModule(data);
		}
		if (data !== undefined && data.FeatureId !== undefined && this.isFeatureApp(data)) {
			this.abandonDeviceFeature(data);
		}
	}

	resetLicense(data: any): void {
		if (data !== undefined && data.FeatureId !== undefined && this.isFeatureApp(data) && this.isAssignApp(data)) {
			this.resetLicenceApp(data);
		}
	}

	revokeInvitationsDevice(data: any): void {
		if (data !== undefined && data.ProductId !== undefined) {
			const invitation = this.getInvitationPendingProduct(data.Id);
			if (invitation !== undefined) {
				this.revokeInvitation(invitation);
			}
		}
		if (data !== undefined && data.ModuleId !== undefined) {
			const invitation = this.getInvitationPendingModule(data.Id);
			if (invitation !== undefined) {
				this.revokeInvitation(invitation);
			}
		}
		if (data !== undefined && data.FeatureId !== undefined) {
			const invitation = this.getInvitationPendingFeature(data.Id);
			if (invitation !== undefined) {
				this.revokeInvitation(invitation);
			}
		}
	}

	revokeAccessDevice(data: any): void {
		if (data !== undefined && data.ModuleId !== undefined && this.isAssignClient(data)) {
			this.revokeAccessDeviceModule(data);
		}
		if (data !== undefined && data.FeatureId !== undefined && this.isAssignApp(data)) {
			this.revokeAccessDeviceFeature(data);
		}
	}

	configAuxiliaryCommands(data: any): void {
		if (data !== undefined && data.ModuleId !== undefined && data.ModuleId === DevicesVctModules.Targa) {
			this.store.dispatch(DeviceVctActions.editVctModuleNameReset());
			this.ref = this.dialogService.open(AuxConfigDeviceVctDialogComponent, {
				header: this.translate.instant('ENABLED') + ' ' + this.translate.instant('AUXILIARY_COMMANDS').toLowerCase(),
				width: '70vw',
				breakpoints: { '1600px': '98vw' },
				contentStyle: { overflow: 'auto' },
				data: {
					moduleId: data.Id,
				},
			});

			// subscribe for dialog closed
			this.ref.onClose.subscribe((somethingIsChanged) => {
				// if click on 'x' dialog, somethingIsChanged is undefined so we refresh
				if (somethingIsChanged || somethingIsChanged === undefined) {
					this.refreshData();
				}
			});
		}
	}
	//-------------------ASSIGN  BUTTON FUNCTION---------------------------------------

	//---------------------- SHARE DIALOGS -------------------------------------------------

	shareDeviceProduct(productId: number): void {
		this.store.dispatch(DeviceVctActions.createVctInvitationsReset());
		this.ref = this.dialogService.open(ShareDeviceVctDialogComponent, {
			header: this.translate.instant('ASSIGN') + ' ' + this.translate.instant('VCT_PLANT').toLowerCase(),
			width: '70vw',
			breakpoints: { '1600px': '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				productId: productId
			},
		});
	}

	shareDeviceModule(moduleId: number): void {
		this.store.dispatch(DeviceVctActions.createVctInvitationsReset());
		this.ref = this.dialogService.open(ShareDeviceVctDialogComponent, {
			header: this.translate.instant('ASSIGN') + ' ' + this.translate.instant('UNIT').toLowerCase(),
			width: '70vw',
			breakpoints: { '1600px': '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				moduleId: moduleId
			},
		});
	}

	shareDeviceFeature(featureId: number): void {
		this.store.dispatch(DeviceVctActions.createVctInvitationsReset());
		this.ref = this.dialogService.open(ShareDeviceVctDialogComponent, {
			header: this.translate.instant('ASSIGN') + ' ' + this.translate.instant('APP_LICENSE').toLowerCase(),
			width: '70vw',
			breakpoints: { '1600px': '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				featureId: featureId
			},
		});
	}
	
	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	actionLayout(position: string): string {
		return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	}

	getSplitString(str: string): string {
		return StandardTruncateString.getSplitString(this.screenWidth, str, 15, 50, 100);
	}
}
